import { Button, Dialog, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import RegistrationForm from './registrationForm/registrationForm';
import { LoginForgotPassword } from './loginForgotPassword';
import MDButton from './MDButton';
import MDTypography from './MDTypography';
import { resources } from 'oems/resources';
import MDBox from 'components/MDBox';
import ResetPasswordComponent from 'features/logon/resetPasswordComponent';
import { OEM } from 'utility/OEMProvider';
import { theme } from 'oems/theme';

export const LoginRegisterStateType = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  SELECTION: 'SELECTION'
};

export default function LoginRegisterChoiceDialog(props) {
  const { onClose, open, onSuccess, onGetUserContext, onCloseStatetype} = props;
  
  const handleClose = (e) => {
    switch (onCloseStatetype) {
      case LoginRegisterStateType.LOGIN: showLogin(); break;
      case LoginRegisterStateType.REGISTER: showRegistration(); break;
      case LoginRegisterStateType.FORGOT_PASSWORD: showForgotPassword(); break;
      default: showSelection();
    };
    onClose(e);
  };

  const showRegistration = () => {
    setopenLogin(false);
    setopenSelection(true);
    setopenRegister(true);
    setForgotPassword(false);
  };
  const showLogin = () => {
    setopenLogin(true);
    setopenSelection(false);
    setopenRegister(false);
    setForgotPassword(false);
  };
  const showSelection = () => {
    setopenLogin(false);
    setopenSelection(true);
    setopenRegister(false);
    setForgotPassword(false);
  };
  const showForgotPassword = () => {
    setopenLogin(false);
    setopenSelection(true);
    setopenRegister(false);
    setForgotPassword(true);
  };

  const [openLogin, setopenLogin] = React.useState(false);
  const [openRegister, setopenRegister] = React.useState(true);
  const [openSelection, setopenSelection] = React.useState(false);
  const [forgotPassword, setForgotPassword] = React.useState(false);

  const loginUserClickHandle = () => {
    showLogin();
  };

  const registerNewUserClickHandle = () => {
    showRegistration();
  };

  return (
    <Stack>
      {openSelection && (
        <Dialog onClose={handleClose} open={open} maxWidth={800}>
          <Stack direction="row" display="flex">
            <Stack id="login-box" direction="column" sx={{ p: '24px' }}>
              <MDBox component="img" src={resources.logoDarkImage} position="relative" width="120px" />
              <Stack direction="row">
                {onClose ? (
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: 'absolute', right: 21, top: 21, color: (theme) => theme.palette.grey[500] }}
                  >
                    <CloseIcon />
                  </IconButton>
                ) : null}
              </Stack>
              {!forgotPassword && (
                <Stack>
                  <MDTypography
                    color="dark"
                    sx={{
                      fontFamily: 'Roboto,Helvetica',
                      fontSize: '24px',
                      fontWeight: 700,
                      mt: '34px',
                      lineHeight: 1.1,
                    }}
                  >
                    Zaloguj się aby kontynuować
                  </MDTypography>

                  <p style={{ marginTop: 10, lineHeight: 1.2, fontSize: 18 }}>
                    Nie masz konta w {OEM().ProductName}?{' '}
                    <span
                      onClick={registerNewUserClickHandle}
                      style={{
                        whiteSpace: 'nowrap',
                        fontWeight: 700,
                        cursor: 'pointer',
                        color: theme.palette.primary.main,
                        fontSize: 20,
                      }}
                    >
                      Zarejestruj się
                    </span>
                  </p>

                  <Stack sx={{ mt: '10px' }}>
                    <LoginForgotPassword onSuccess={onSuccess} />
                    <Button
                      variant="text"
                      onClick={showForgotPassword}
                      fullWidth
                      sx={{
                        fontSize: '13px',
                        textTransform: 'none',
                        fontWeight: 700,
                        color: (theme) => theme.palette.info.main,
                      }}
                    >
                      Zapomniałeś hasła?
                    </Button>
                  </Stack>
                </Stack>
              )}
              {forgotPassword && (
                <Stack>
                  <MDTypography
                    color="dark"
                    sx={{ fontFamily: 'Roboto,Helvetica', fontSize: '24px', fontWeight: 700, mt: '34px' }}
                  >
                    Nie pamiętasz hasła?
                  </MDTypography>
                  <MDTypography
                    color="dark"
                    sx={{ fontFamily: 'Roboto,Helvetica', fontSize: '14px', fontWeight: 500, mt: '20px' }}
                  >
                    Nie martw się, podaj swój adres email - wyślemy instrukcje jak ustawić nowe hasło.
                  </MDTypography>
                  <Stack sx={{ mt: '42px' }}>
                    <ResetPasswordComponent />
                    <Button
                      variant="text"
                      onClick={showSelection}
                      fullWidth
                      sx={{
                        fontSize: '13px',
                        textTransform: 'none',
                        fontWeight: 700,
                        color: (theme) => theme.palette.info.main,
                      }}
                    >
                      {'< Powrót do logowania'}
                    </Button>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Stack>
        </Dialog>
      )}{' '}
      {openRegister && (
        <Dialog onClose={handleClose} open={open} maxWidth={props.maxWidth}>
          <Stack id="register-box" direction="column" sx={{ p: '24px' }}>
            <MDBox component="img" src={resources.logoDarkImage} position="relative" width="120px" />
            <Stack direction="row">
              {onClose ? (
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{ position: 'absolute', right: 21, top: 21, color: (theme) => theme.palette.grey[500] }}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
              <Stack>
                <MDTypography
                  color="dark"
                  sx={{
                    fontFamily: 'Roboto,Helvetica',
                    fontSize: '24px',
                    fontWeight: 700,
                    mt: '34px',
                    lineHeight: 1.1,
                  }}
                >
                  Witaj w {OEM().ProductName}, stwórz konto
                </MDTypography>

                <p style={{ marginTop: 10, lineHeight: 1.2, fontSize: 18 }}>
                  Masz konto w {OEM().ProductName}?{' '}
                  <span
                    onClick={showSelection}
                    style={{
                      whiteSpace: 'nowrap',
                      fontWeight: 700,
                      cursor: 'pointer',
                      color: theme.palette.primary.main,
                      fontSize: 20,
                    }}
                  >
                    Zaloguj się
                  </span>
                </p>
              </Stack>
            </Stack>
            <Stack sx={{ mt: '10px' }}>
              <RegistrationForm onClose={handleClose} onSuccess={onSuccess} onGetUserContext={onGetUserContext}/>
            </Stack>
          </Stack>
        </Dialog>
      )}
      {openLogin && (
        <Dialog onClose={handleClose} open={open} maxWidth={props.maxWidth}>
          <DialogTitle>
            <MDBox component="img" src={resources.logoDarkImage} width="164px" sx={{ ml: 1, my: 1 }} />
            <Stack direction="row" justifyContent="flex-start" alignItems="center">
              {onClose ? (
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{ position: 'absolute', right: 1, top: 1, color: (theme) => theme.palette.grey[500] }}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </Stack>
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ display: 'flex', justifyContent: 'stretch', flexFlow: 'row', alignItems: 'stretch' }}>
            <Stack flex={2} direction="column" justifyContent="center" alignItems="center" spacing={1} sx={{ m: 0 }}>
              <LoginForgotPassword onSuccess={onSuccess} />
              <MDButton
                variant="text"
                onClick={setForgotPassword}
                fullWidth
                sx={{
                  fontSize: '13px',
                  textTransform: 'none',
                  fontWeight: 700,
                  color: (theme) => theme.palette.info.main,
                }}
              >
                Zapomniałeś hasła?
              </MDButton>
              :<div />
            </Stack>
          </DialogContent>
        </Dialog>
      )}
    </Stack>
  );
}
